import { render, staticRenderFns } from "./RegistrationQueue.vue?vue&type=template&id=9414c67e&scoped=true"
import script from "./RegistrationQueue.vue?vue&type=script&lang=js"
export * from "./RegistrationQueue.vue?vue&type=script&lang=js"
import style0 from "./RegistrationQueue.vue?vue&type=style&index=0&id=9414c67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9414c67e",
  null
  
)

export default component.exports